import { Button, Input, message } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import CartProducts from "../../components/CartProducts/CartProducts";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import SubscribeOrder from "../../components/SubscribeOrder/SubscribeOrder";
import {
  CheckOutlined
} from "@ant-design/icons";
import localization from '../../Localization/Localization.json'

import "./cart.scss";
import AddressModal from "../../components/AddressModal/AddressModal";
import { applyPromoCode, applyRemovePromoCode } from "../../network/cart.network";
import { fallbackImg } from "../../constants/constants";
import { Link, withRouter } from "react-router-dom";
import ResNavBar from "../../components/ResNavBar/ResNavBar";
import { fetchCart } from "../../network/product.network";
import { setAddressUser, setPaymentUser } from "../../redux/user/user.action";
import SelectPayMethod from "../../components/SelectPayMethod/SelectPayMethod";
import { addProductToCart, clearCart } from "../../redux/cart/cart.action";
class Cart extends Component {
  state = {
    showModalVisible : false,
    showPayModal : false,
    codeLoading : false,
    Promo_code : "",
    cartItems : [],
    isLoading : true,
    cartInfo : null,
    subscriptionType : null
  }

  
  componentDidMount() {
    fetchCart((res) => {
      this.setState({isLoading : true, subscriptionType : res.data.data.cart.subscriptionType})
      console.log(res.data.data.cart) 
      if(res.data.data.cart?.totals?.promoCode){
        this.setState({Promo_code : res.data.data.cart?.totals?.promoCode}) 
      }
      this.props.dispatch(setAddressUser(res.data.data.cart?.address))  
      this.props.dispatch(setPaymentUser(res.data.data.cart?.paymentType)) 
      if(!this.props.currentPayment){ 
        if(res.data.data.cart?.paymentType){
          this.props.dispatch(setPaymentUser(res.data.data.cart?.paymentType)) 
        }
      }

      this.props.dispatch(clearCart());
      setTimeout(() => { 
        res.data.data.cart.items.forEach(ele => { 
        const isProductExistInStorage = this.props.cartItems?.some(
          (product) => +product.id === +ele.productId
        );
        if (!isProductExistInStorage) {
          this.props.dispatch(addProductToCart({ ...ele, 
            productId : +ele.id,
            id : +ele.productId,
            inCart: {  
              itemId: +ele.id,  
              quantity: +ele.quantity,
            },
           }));
        }
      })
      }, 300)  

      this.setState({cartInfo : res.data.data.cart, cartItems : res.data.data.cart.items.map(item => (
        {...item, 
          productId : +item.id,
          id : +item.productId,
          inCart: {  
            itemId: +item.id,  
            quantity: item.quantity,
          },
      })) , isLoading : false})  
  }, (error) => {
      this.setState({ isLoading : false})
      console.log(error) 
  })

  }

  removeCardInCard = (id) => {
    console.log(id, "sdfasdf");
    // const filterList = this.state.cartItems.filter(card => card.id !== id)
    // this.setState({cartItems : filterList})  
    fetchCart((res) => { 
      this.setState({isLoading : true, subscriptionType : res.data.data.cart.subscriptionType})
      console.log(res.data.data.cart) 
      if(res.data.data.cart?.totals?.promoCode){
        this.setState({Promo_code : res.data.data.cart?.totals?.promoCode}) 
      }
      this.props.dispatch(setAddressUser(res.data.data.cart?.address))  
      this.props.dispatch(setPaymentUser(res.data.data.cart?.paymentType)) 
      if(!this.props.currentPayment){ 
        if(res.data.data.cart?.paymentType){
          this.props.dispatch(setPaymentUser(res.data.data.cart?.paymentType)) 
        }
      }

      this.props.dispatch(clearCart());
      setTimeout(() => { 
        res.data.data.cart.items.forEach(ele => { 
        const isProductExistInStorage = this.props.cartItems?.some(
          (product) => +product.id === +ele.productId
        );
        if (!isProductExistInStorage) {
          this.props.dispatch(addProductToCart({ ...ele, 
            productId : +ele.id,
            id : +ele.productId,
            inCart: {  
              itemId: +ele.id,  
              quantity: +ele.quantity,
            },
           }));
        }
      })
      }, 300)  

      this.setState({cartInfo : res.data.data.cart, cartItems : res.data.data.cart.items.map(item => (
        {...item, 
          productId : +item.id,
          id : +item.productId,
          inCart: {  
            itemId: +item.id,  
            quantity: item.quantity,
          },
      })) , isLoading : false})  
  }, (error) => {
      this.setState({ isLoading : false})
      console.log(error) 
  })
  } 

  handelPromoCode = () => {
    const { Promo_code, cartInfo } = this.state;
    this.setState({ codeLoading: true });
    let body = new FormData();
    body.append("promocode", Promo_code);
    applyPromoCode(
      body,
      (res) => {
        this.setState({ codeLoading: false });
        if (res.data.code === 200) {
          message.success(res.data.message);
          this.setState({cartInfo : {...cartInfo, totals : {...cartInfo.totals, promoCode : Promo_code}}}) 
        }
      },
      (error) => {
        this.setState({ codeLoading: false });
        console.log(error); 
      }
    );
  };

  handelRemovePromoCode = () => {
    const { cartInfo } = this.state;
    this.setState({ codeLoading: true });
    let body = new FormData();
    body.append("promocode", cartInfo?.totals?.promoCode);
    applyRemovePromoCode(
      body,
      (res) => {
        this.setState({ codeLoading: false });
        if (res.data.code === 200) {
          message.success(res.data.message);
          this.setState({cartInfo : {...cartInfo, totals : {...cartInfo.totals, promoCode : null}}})  
        }
      },
      (error) => {
        this.setState({ codeLoading: false });
        console.log(error); 
      }
    );
  };

  handelCheckoutRoute = () => {
    console.log(this.props.currentAddress);
    if(!this.props.currentUser){  
      message.warning(localization.pleaseloginproceedcartorder[this.props.currentLang])
      return false;  
    }
    if(!this.props.currentAddress){  
      message.warning(localization.pleaseselectaddresscontinue[this.props.currentLang])
    }else if(!this.props.currentPayment){
      message.warning(localization.pleaseselectpaymentcontinue[this.props.currentLang])
    }else if(this.state.cartItems.length === 0){
      message.warning(localization.YourCartEmpty[this.props.currentLang]) 
    }
    else{
      this.props.history.push("/checkout");
    }
  }

  resetCart = () => {
    this.setState({cartItems : []})
  }

  setPaymentCallBack = (Type) => {
    const { cartInfo } = this.state; 
    this.setState({cartInfo : {...cartInfo, paymentType : Type, totals : {...cartInfo.totals, paymentType : Type}}})  
  }
  

  render() {
    const {showModalVisible, codeLoading, cartItems, isLoading, cartInfo, showPayModal, subscriptionType} = this.state;
    const {currentLang, currentAddress} = this.props;
    return (
      <div className="cart-page-wrapper">
        <Header />
        <AddressModal noSetAddressLocal closeModal={() => this.setState({showModalVisible : false}) } showModalVisible={showModalVisible} />

        <SelectPayMethod 
        closeModal={() => this.setState({showPayModal : false}) } 
        showModalVisible={showPayModal} currentLang={currentLang} 
        localization={localization} 
        setPaymentCallBack={(Type) => this.setPaymentCallBack(Type)} /> 

        <div className="container">
          <div className="cart-content-wrapper">
            <div className="cart-main"> 
              <SubscribeOrder localization={localization} subscriptionType = {subscriptionType} />
              <CartProducts resetCart={() => this.resetCart()} removeCardInCard={(id) => this.removeCardInCard(id)} isLoading={isLoading} cartItemsList={cartItems} />  
            </div>
            <div className="cart-aside">
              <div className="cart-aside-content">
                <h4 className="cart-aside-title">
                {localization.OrderSummary[currentLang]}
                </h4>
                <div className="cart-aside-card">
                  <h6 className="cart-aside-card--title">{localization.Deliverto[currentLang]}</h6>
                  {currentAddress ? 
                  <div className="aside-card-row">
                    <h4 className="card-row-title"> 
                          {currentAddress.city_name + ", Street No. " + currentAddress.street_number + ", floor " + currentAddress.floor + "," + currentAddress.landmark }  
                          { ", " + currentAddress.note && currentAddress.note}   
                      </h4> 
                    <p className="card-row-btn" onClick={() => this.setState({showModalVisible : true}) }>{localization.CHange[currentLang]}</p>
                  </div>
                    : 
                  <div className="aside-card-row">
                    <p className="card-row-btn" onClick={() => {
                      if(!this.props.currentUser){  
                        message.warning(localization.pleaseloginproceedcartorder[this.props.currentLang])
                        return false;  
                      }
                      this.setState({showModalVisible : true}) 
                    } }>{localization.selectAddress[currentLang]}</p> 
                  </div>} 
                </div>
                <div className="cart-aside-card">
                  <h6 className="cart-aside-card--title">{localization.Paywith[currentLang]}</h6> 

                  {cartInfo?.paymentType ? 
                      <div className="aside-card-row">
                      {/* <div className="card-row-pay"> 
                      </div>  */}
                      <h4 className="card-row-title"> 
                          {cartInfo?.paymentType?.name}
                      </h4> 
                      <p className="card-row-btn" onClick={() => this.setState({showPayModal : true})} >{localization.CHange[currentLang]}</p> 
                    </div> 
                    : 
                  <div className="aside-card-row">
                    <p className="card-row-btn" onClick={() => {
                      if(!this.props.currentUser){  
                        message.warning(localization.pleaseloginproceedcartorder[this.props.currentLang])
                        return false;  
                      }
                      this.setState({showPayModal : true})
                    } }>{localization.selectpaymentmethod[currentLang]}</p> 
                  </div>}
                </div>
                <div className="cart-aside-promo">
                  <div className="cart-aside-promo--header">
                      <h6 className="promo--title">{localization.Promocode[currentLang]}</h6>
                      {
                        cartInfo?.totals?.promoCode &&
                        <p className="promo--status">{localization.CodeApplied[currentLang]} <CheckOutlined /></p>
                      }
                  </div>
                  <div className="promo-apply">
                  <Input placeholder={localization.Entervalidpromocode[currentLang]} value={this.state.Promo_code} onChange={(e) => this.setState({Promo_code : e.target.value}) } /> 
                  {cartInfo?.totals?.promoCode ? 
                  <Button size="large" type="danger" onClick={this.handelRemovePromoCode} loading={codeLoading}>{localization.Remove[currentLang]}</Button>
                 :
                  <Button size="large" type="primary" onClick={this.handelPromoCode} loading={codeLoading}>{localization.Apply[currentLang]}</Button>
                  }
                  </div>
                </div>
              </div>
                <Button size="large" type="primary" block style={{marginBottom : 18}} onClick={this.handelCheckoutRoute}>
                  {/* <Link to="/checkout"> */}
                  {localization.Proceedtocheckout[currentLang]}
                  {/* </Link> */}
                  </Button>
                <Button size="large" type="primary" ghost block>
                  <Link to="/">
                  {localization.ContinueShopping[currentLang]}
                  </Link>
                  </Button>
            </div>
          </div>
        </div>
        <Footer />
        <ResNavBar /> 
      </div>
    );
  }
}
const CartWithRouter = withRouter(Cart); 
const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang,
  currentAddress : state.user.currentAddress,
  currentPayment : state.user.currentPayment,
  currentUser : state.user.currentUser 
});

export default connect(mapStateToProps)(CartWithRouter);
